import { render, staticRenderFns } from "./contractList.vue?vue&type=template&id=65bf5f3e&scoped=true"
import script from "./contractList.vue?vue&type=script&lang=js"
export * from "./contractList.vue?vue&type=script&lang=js"
import style0 from "./contractList.vue?vue&type=style&index=0&id=65bf5f3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bf5f3e",
  null
  
)

export default component.exports